import { useEffect, useState, useCallback } from "react";
import ActiveOrder from "./component";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import axios from "axios";
import ActiveOrderSkeleton from "./ActiveOrderSkeleton.jsx";
import logger from "../../Utils/logger";

const ActiveOrderContainer = () => {
  const navigate = useNavigate();
  const { orderId } = useParams();
  const UserJWTAuth = localStorage.getItem("UserJWTAuth");
const [calimPopupFlag, setCalimPopupFlag] = useState(false);
  const [activeOrder, setActiveOrder]       = useState(null);
  const [loader, setLoader]                 = useState(false);
  const [busyPopupFlag, setBusyPopupFlag]   = useState(false);
  const [machineError, setMachineError]     = useState(null);
  const [cancleflag, setCancleflag]         = useState(false);
  const [cancleOrderID, setCancleOrderID]   = useState(null);
  const [cancleErrorflag, setCancleErrorflag]   = useState(false);
  const [cancleErrorMsg, setCancleErrorMsg]     = useState("");
  const [cancleSuccessflag, setCancleSuccessflag] = useState(false);
  const [cancleSuccessMsg, setCancleSuccessMsg]   = useState("");
  const [initialLoading, setInitialLoading] = useState(true);
const [claimPopupFlag2, setClaimPopupFlag2] = useState(false);
  const { makeApiRequest } = useApiRequest();

  const defaultHeaders = {
    Authorization: `Bearer ${UserJWTAuth}`,
    "x-app-platform": "web",
    "x-app-version": "v1.0.1",
    "x-device-id": localStorage.getItem("uuid"),
  };

  // ─── Fetch Order ────────────────────────────────────────────────────────────
  const fetchActiveOrder = useCallback((showFullLoader = false) => {
    if (showFullLoader) setLoader(true);

    makeApiRequest({
      url: `${process.env.REACT_APP_API_BASE_URL}/consumerbe/api/v2/order/${orderId}`,
      method: "GET",
      headers: defaultHeaders,
      handleSuccess: (res) => {
        setActiveOrder(res.data.data);
        setInitialLoading(false);
        setLoader(false);
      },
      handleError: (error) => {
        setInitialLoading(false);
        setLoader(false);
        const status = error.response?.status;
        if (status === 401 || status === 403) {
          navigate("/login");
          return;
        }
        toast.error(
          error.response?.data?.status?.message || "Failed to load order",
          { position: toast.POSITION.TOP_RIGHT, autoClose: 2000 }
        );
      },
    });
  }, [orderId]);

  useEffect(() => {
    if (!UserJWTAuth) {
      navigate("/login");
      return;
    }
    fetchActiveOrder();
  }, []);

  // ─── Fetch Vend Code ────────────────────────────────────────────────────────
  const fetchCode = async () => {
    setLoader(true);
    try {
      await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/consumerbe/api/v1/contactless/generate-code/${orderId}`,
        { headers: defaultHeaders }
      );
      setBusyPopupFlag(false);
      setLoader(false);
      navigate(`/vendOrder/number/${orderId}`, { replace: true });
    } catch (err) {
      setLoader(false);
      setBusyPopupFlag(true);
      const code    = err.response?.data?.status?.code;
      const message = err.response?.data?.status?.message ?? "";
      if (code === "FORBIDDEN") {
        const isOffline =
          message.toLowerCase().includes("offline") ||
          message.toLowerCase().includes("office");
        setMachineError(isOffline ? "Offline" : "Busy");
      } else {
        toast.error(message || "Could not connect to machine", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        });
      }
    }
  };

  // ─── Cancel Order ───────────────────────────────────────────────────────────
  const CancleOrder = () => {
    if (!cancleOrderID) return;
    setLoader(true);

    makeApiRequest({
      url: `${process.env.REACT_APP_API_BASE_URL}/consumerbe/api/v2/order/${cancleOrderID}`,
      method: "DELETE",
      headers: defaultHeaders,
      handleSuccess: (res) => {
        setLoader(false);
        setCancleflag(false);
        if (res.data.status.success) {
          setCancleSuccessflag(true);
          setCancleSuccessMsg("Order cancelled successfully");
          fetchActiveOrder(); // refresh silently
        } else {
          setCancleErrorflag(true);
          setCancleErrorMsg(res.data.status.message || "Unable to cancel order");
        }
      },
      handleError: (error) => {
        setLoader(false);
        setCancleflag(false);
        setCancleErrorflag(true);
        setCancleErrorMsg(
          error.response?.data?.status?.message || "Something went wrong"
        );
      },
    });
  };

  const CancleOrderset = (e, id) => {
    setCancleOrderID(id);
    setCancleflag(true);
  };
 
    const claimDigital = (lineItemId) => {
      logger.log("claimDigital called with lineItemId:", lineItemId);
       makeApiRequest({
        url: `${process.env.REACT_APP_API_BASE_URL}/consumerbe/api/v1/digital/claim`,
        method: "POST",
        headers: defaultHeaders,
        data: {
          digitalLineItemId: lineItemId,
          //emailId: email,
        },
        handleSuccess: () => {
          setClaimPopupFlag2(true);
     
        },
        handleError: (err) => {

          const msg =
            err?.response?.data?.status?.message || "Claim failed. Please try again.";
          toast.error(msg);
        },
      });
    };

    // Same claim endpoint, plus the verified emailId — used for items with isEmailRequired,
    // after the email/OTP step. Shares claimPopupFlag2's success dialog with claimDigital().
    const claimDigitalWithEmail = (lineItemId, email) => {
      makeApiRequest({
        url: `${process.env.REACT_APP_API_BASE_URL}/consumerbe/api/v1/digital/claim`,
        method: "POST",
        headers: defaultHeaders,
        data: {
          digitalLineItemId: lineItemId,
          emailId: email,
        },
        handleSuccess: () => {
          setClaimPopupFlag2(true);
        },
        handleError: (err) => {
          const msg =
            err?.response?.data?.status?.message || "Claim failed. Please try again.";
          toast.error(msg);
        },
      });
    };

  // ─── Render ─────────────────────────────────────────────────────────────────
  if (initialLoading) return <ActiveOrderSkeleton />;

  return (
    
    <ActiveOrder
      activeOrder={activeOrder}
      loader={loader}
      // cancel
      cancleflag={cancleflag}
      setCancleflag={setCancleflag}
      CancleOrder={CancleOrder}
      CancleOrderset={CancleOrderset}
      // cancel error
      cancleErrorflag={cancleErrorflag}
      setCancleErrorflag={setCancleErrorflag}
      cancleErrorMsg={cancleErrorMsg}
      setCancleErrorMsg={setCancleErrorMsg}
      // cancel success
      cancleSuccessflag={cancleSuccessflag}
      setCancleSuccessflag={setCancleSuccessflag}
      cancleSuccessMsg={cancleSuccessMsg}
      // machine / vend
      busyPopupFlag={busyPopupFlag}
      setBusyPopupFlag={setBusyPopupFlag}
      machineError={machineError}
      fetchCode={fetchCode}
      fetchActiveOrder={fetchActiveOrder}
      claimDigital={claimDigital}
      claimDigitalWithEmail={claimDigitalWithEmail}

      setClaimPopupFlag2={setClaimPopupFlag2}
      claimPopupFlag2={claimPopupFlag2}
      fetchActiveOrder={fetchActiveOrder}
    />
  );
};

export default ActiveOrderContainer;